export default __webpack_public_path__ + "static/media/gratitude_coin.e081e0e5.png";